import { supabase } from '../../shared/supabase/supabaseClient';
import { captureCatch } from '../../shared/sentry/sentryUser';

/**
 * #1296: batch — una sola RPC devuelve las branch_ids con sesión de caja
 * abierta (hub post-login muestra "Caja abierta/cerrada" por sucursal).
 * `null` = fallo/desconocido (el picker muestra "Caja —", nunca "cerrada"
 * por defecto). Los errores se reportan a Sentry.
 */
export async function listBranchesWithOpenCashSession(
  branchIds: string[],
): Promise<Set<string> | null> {
  if (branchIds.length === 0) return new Set();
  try {
    const { data, error } = await supabase.rpc('list_branches_with_open_cash_session', {
      p_branch_ids: branchIds,
    });
    if (error) throw error;
    if (!Array.isArray(data)) return null;
    return new Set(
      (data as { branch_id?: unknown }[])
        .map((row) => row.branch_id)
        .filter((id): id is string => typeof id === 'string'),
    );
  } catch (err) {
    captureCatch('cash', 'open_cash_sessions_batch')(err);
    return null;
  }
}
